// Which manifest video each nudge offers as "Watch how" (KPR-1929). One line
// per surface: a content change is an edit here, never to a component. A key
// the compiled manifest does not hold draws nothing, so a key may be set
// before its video is published. Keys follow docs/videos/README.md.
export const WATCH_HOW_VIDEOS = {
	noCards: 'howto-create-a-card-h',
	noItems: 'howto-add-an-item-h',
	noElements: 'howto-add-an-element-h',
	personalCollection: 'howto-your-personal-collection-h',
};
